export const message = {
  requestFailure:'请求数据失败',
  pleaseSelect:'请选择',
  pleaseInput:'请输入',
  pleaseEnterAgain:'请再次输入',
  cancel:'取消',
  confirm:'确定',
  tips:'提示',
  changePassword:'修改密码',
  originalPassword:'原密码',
  newPassword:'新密码',
  confirmPassword:'确认密码',
  noData:'暂无数据',
  toAudited:'待审核',
  toShipped:'待发货',
  receivable:'待收款',
  dateTime:'日期',
  orderNumber:'订单数',
  orderAmount:'订单额',
  singular:'单数',
  amountMoney:'金额',
  yes:'是',
  no:'否',
  chooseNcode:'请选择区号',
  chooseGoods:'请选择商品',
  chooseOrder:'请选择订单',
  chooseCustomer:'请选择客户',
  examine:'审核',
  delete:'删除',
  outStock:'出库',
  receivables:'收款',
  printing:'打印',
  merge:'合并',
  printNow:'立即打印',
  operation:'操作',
  see:'查看',
  allElection:'全选',
  query:'查询',
  empty:'清空',
  newlyBuild:'新建',
  edit:'编辑',
  batchImport:'批量导入',
  export:'导出',
  goodsNameBarCode:'商品名称或条码',
  brand:'品牌',
  class:'分类',
  subclass:'子分类',
  state:'状态',
  upperShelf:'上架',
  lowerShelf:'下架',
  inventory:'盘点中',
  batchDownShelf:'批量下架',
  batchDeletion:'批量删除',
  itemNumber:'货号',
  store:'门店',
  goodsStatus:'商品状态',
  stockStatus:'库存状态',
  inStock:'有货',
  noGoods:'无货',
  orderNum:'订单号',
  orderStatus:'订单状态',
  pendingPayment:'待付款',
  shipped:'已发货',
  completed:'已完成',
  cancelled:'已取消',
  invalid:'已作废',
  receivabless:'已收款',
  paymentStatus:'付款状态',
  startDate:'开始日期',
  endDate:'结束日期',
  customerName:'客户名称',
  salesperson:'销售员',
  orderSource:'订单来源',
  valetOrder:'代客下单',
  salesmenOrders:'业务员下单',
  weChatShop:'微信店铺',
  effective:'有效',
  invalids:'无效',
  goodsPictures:'商品图片',
  numberBarCode:'货号 / 条码',
  goodsName:'商品名称',
  spec:'规格',
  company:'单位',
  unitPriceSales:'销售单价',
  costUnitPrice:'成本单价',
  availableStock:'可售库存',
  returnStock:'退货库存',
  salesInventory:'销售库存',
  downloadTemplate:'下载模板',
  drag:'将文件拖到此处，或',
  clickUpload:'点击上传',
  uploadFailure:'上传失败',
  uploadXLS:'上传文件只能是 xls 格式!',
  orderTime:'下单时间',
  orderAmounts:'订单金额',
  amountReceived:'已收金额',
  barcodeGeneration:'生成条码',
  goodsInformation:'商品信息',
  goodsClassification:'商品分类',
  goodsBrand:'商品品牌',
  mainUnit:'主单位',
  auxiliaryUnit:'辅单位',
  quaranteeQuality:'保质期',
  day:'天',
  month:'月',
  upperChannel:'上架渠道',
  microMall:'微店铺',
  jieldOperations:'外勤业务端',
  specificationSet:'规格设置',
  singleSpec:'单规格',
  multiSpec:'多规格',
  formName:'规格名称',
  attributeName:'属性名称',
  displayMap:'展示图',
  barCode:'条码',
  costPrice:'成本价',
  sellingPrice:'销售价',
  goodsPrice:'商品价格',
  retailPrice:'零售价',
  ladderPrice:'批发阶梯价',
  retailDescribe:'零售单位默认对应辅单位，若未设置辅单位，零售单位默认为主单位。需使用收银功能的商品必须填写零售价',
  ladderDescribe:'批发单位默认对应主单位。需使用订单功能的商品必须填写批发价',
  startingQuantity:'起订量',
  goodsDetails:'商品详情',
  detailMap:'详情图',
  describe:'描述',
  settingPoints:'提点设置',
  pointType:'提点类型',
  nothing:'无',
  inProportion:'按比例',
  accordingQuantity:'按量',
  pointValue:'提点值',
  eachStroke:'每笔',
  save:'保存',
  return:'返回',
  newAttribute:'新增属性',
  enterNameProduct:'请输入商品名称',
  chooseGoodsClassification:'请选择商品分类',
  selectGoodsUnits:'请选择商品单位',
  chooseBrandGoods:'请选择商品品牌',
  selectStatus:'请选择状态',
  enterPropertyName:'请输入属性名称',
  specCannotRepeated:'规格不能重复',
  superiorStartingQuantity:'不能小于上级起订量',
  salesPriceSuperiorLevel:'不能大于上级销售价',
  uploadUpPictures:'最多上传9张图片',
  uploadHeadPictureFormat:'上传头像图片只能是 JPG 或 PNG 格式!',
  uploadHeadImageSize:'上传头像图片大小不能超过 1MB!',
  firstLadderPriceCannotEmpty:'第一阶梯价不能为空',
  attribute:'属性',
  brandName:'品牌名称',
  newBrand:'新建品牌',
  editBrand:'编辑品牌',
  enterBrandName:'请输入品牌名称',
  chooseBrand:'请选择品牌',
  classificationName:'分类名称',
  subcategoryName:'子分类名称',
  adSubcategories:'添加子分类',
  batchDeleSubclass:'批量删除子分类',
  newClass:'新建分类',
  superiorCategoryName:'上级分类名称',
  editCass:'编辑分类',
  enterCategoryName:'请输入分类名称',
  selectSubcategories:'请选择子分类',
  stockEarlyWarning:'库存预警',
  upperLimit:'上限',
  lowerLimit:'下限',
  colorName:'颜色名称',
  sizeName:'尺码名称',
  commodityLadderPrice:'商品阶梯价',
  chooseLeastColorSize:'请至少选择一个颜色或尺码',
  addAttribute:'添加属性',
  batchDeleteSpecification:'批量删除规格',
  batchDeletionAttributes:'批量删除属性',
  newSpecifications:'新建规格',
  editSpecification:'编辑规格',
  editAttribute:'编辑属性',
  enterSpecName:'请输入规格名称',
  attributeCannotEmpty:'属性不能为空',
  selectSpec:'请选择规格',
  selectAttributes:'请选择属性',
  remainingShelfLifeDays:'剩余保质期天数',
  frozenStock:'冻结库存',
  dateStorage:'入库日期',
  dateManufacture:'生产日期',
  enterRemainingShelfLifeDays:'请输入剩余保质期天数',
  unitName:'单位名称',
  newUnit:'新建单位',
  editUnit:'编辑单位',
  enterNameUnit:'请输入单位名称',
  selectUnit:'请选择单位',
  nearlyQiDays:'近7天',
  nearlySanShidays:'近30天',
  nearlyJiuShiDays:'近90天',
  totalAmount:'金额合计',
  amountCollected:'待收金额',
  preferentialAmount:'优惠金额',
  generationIcon:'【代】',
  tradeIcon:'【业】',
  storeIcon:'【店】',
  batchOperation:'批量操作',
  purchasing:'加入采购',
  fullParticipation:'全部加入采购',
  requirement:'需求量',
  allGoodsPurchased:'商品已全部加入采购',
  boss:'老板',
  inside:'内勤',
  cashiers:'收银员',
  salesman:'业务员',
  customerInformation:'客户信息',
  distributionMode:'配送方式',
  num:'数量',
  unitPrice:'单价',
  subtotal:'小计',
  remarks:'备注',
  tradePrice:'批发价',
  lastUnitPrice:'上次成交单价',
  discountRate:'折扣率',
  concessionTotal:'优惠合计',
  discountAmount:'折扣额',
  totalOrders:'订单总额',
  selectCustomerName:'请选择客户名称',
  total:'合计',
  discountPleaseEnter:'如8折请输入80',
  receivingAddress:'收货地址',
  discountAmounts:'折扣金额',
  commodityAmount:'商品金额',
  freightAmount:'运费金额',
  depositDeliveryRecords:'出库/发货记录',
  outgoingNumber:'出库单号',
  outgoingTime:'出库时间',
  personCharge:'经办人',
  brandCommodityNameSpec:'品牌 / 商品名称 / 规格',
  outVolume:'出库量',
  collectionRecords:'收款记录',
  amountPayable:'应付金额',
  unpaidAmount:'未付金额',
  amountPaid:'已付金额',
  collectionTime:'收款时间',
  amountCollecteds:'收款金额',
  receipts:'收款备注',
  toVoid:'作废',
  orderRemark:'订单备注',
  buyerMessage:'买方留言',
  ccrapOrder:'作废订货单',
  chooseTimeCollection:'请选择收款时间',
  enterAmountReceipt:'请输入收款金额',
  paymentTime:'付款时间',
  paymentAmount:'付款金额',
  operator:'操作人',
  invalidDescription:'单据作废将撤销相应的库存、账务，且作废后数据不可恢复，作废?',
  cancellationNum:'退单号',
  returningWarehouse:'退货入库方式',
  returnReason:'退货原因',
  packageBreakage:'包装破损',
  qualityProblem:'质量问题',
  onSchedule:'临期',
  refundAmount:'退款金额',
  confirmationStatement:'确认说明',
  confirmationTime:'确认时间',
  confirmingPerson:'确认人',
  wasteReturnBill:'作废退货单',
  changeNum:'换单号',
  pendingProcessing:'待换处理',
  repair:'【补】',
  retreat:'【退】',
  chooseGoodsReturned:'请选择退货商品',
  chooseGoodsExchange:'请选择换货商品',
  returnedGoods:'退货商品列表',
  exchangeList:'换货商品列表',
  exportInventoryTemplate:'导出库存模板',
  storageTemplate:'入库模板',
  inventoryTemplate:'盘点模板',
  totalInventoryAmount:'库存总金额',
  tightStock:'库存紧张',
  stockAmount:'库存金额',
  warningValue:'预警值',
  settingWarningValue:'设置库存预警值',
  enterWarningValue:'请输入预警值',
  businessOddNum:'业务单号',
  type:'类型',
  stockUnit:'库存单位',
  dateChange:'变更日期',
  nameStore:'门店名称',
  changeType:'变更类型',
  operationType:'操作类型',
  amountChange:'变更量',
  currentInventory:'当前库存',
  warehousing:'入库',
  purchaseWarehousing:'采购入库',
  returnStorage:'退货入库',
  returnWarehouse:'退货入销库',
  returnWarehouses:'退货入退库',
  otherWarehousing:'其他入库',
  transferWarehouses:'调货入库',
  salesOutlet:'销售出库',
  returnOutStock:'退货出库',
  exchangeOutStock:'换货出库',
  otherOutlets:'其他出库',
  transferOutStock:'调货出库',
  inventorys:'盘点',
  inventorySale:'盘点平账(售)',
  inventoryRefund:'盘点平账(退)',
  warehouseReceipt:'入库单号',
  storageType:'入库类型',
  businessSingleNum:'关联业务单号',
  warehousingTime:'入库时间',
  selectWarehouseReceipt:'请选择入库单',
  unitPriceWarehousingCost:'上次入库成本单价',
  selectTypeStorage:'请选择入库类型',
  selectStorageTime:'请选择入库时间',
  auditTime:'审核时间',
  auditor:'审核人',
  scheduledReceipt:'入库量',
  outgoingSingleNum:'出库单号',
  outgoingType:'出库类型',
  selectOutReceipt:'请选择出库单',
  selectTypeLibraryExit:'请选择出库类型',
  chooseTimeLeaveWarehouse:'请选择出库时间',
  warehousesCanSame:'调出仓库与调入仓库不能相同',
  allocationOddNum:'调拨单号',
  transferWarehouse:'调出仓库',
  transferWarehousess:'调入仓库',
  transferAudit:'调入审核',
  dismissal:'调入驳回',
  auditOut:'调出审核',
  dismissals:'调出驳回',
  outStocks:'待出库',
  pendingStorage:'待入库',
  allocationTime:'调拨时间',
  selectTransferOrder:'请选择调拨单',
  chooseTransferOutWarehouse:'请选择调出仓库',
  chooseTransferWarehouse:'请选择调入仓库',
  transferVolume:'调货量',
  reject:'驳回',
  checkOddNum:'盘点单号',
  inventoryTime:'盘点时间',
  actualInventory:'实际库存',
  sell:'【售】',
  selectInventoryTime:'请选择盘点时间',
  enterCorrectNumber:'请输入一个正确的数字',
  enterProductNameBarCode:'输入商品名称或条码',
  batchSelection:'批量选择',
  shortage:'缺货',
  pleaseChooseCommodity:'请选择一个商品',
  exportCommodities:'导出商品',
  purchaseOrderNum:'采购单号',
  warehouse:'仓库',
  procurementTime:'采购时间',
  selectPurchaseOrder:'请选择采购单',
  selectWarehouse:'请选择仓库',
  purchaseVolume:'采购量',
  bulkPurchase:'批量采购',
  demandInventory:'需求库存',
  customerType:'客户类型',
  microshopSalesman:'微店业务员',
  areaGrouping:'区域分组',
  priceGroupings:'价格分组',
  newClient:'新建客户',
  contacts:'联系人',
  contactNumber:'联系电话',
  location:'所在区域',
  province:'省',
  city:'市',
  area:'区',
  detailedAddress:'详细地址',
  editClient:'编辑客户',
  customerSalesmanGrouping:'设置客户业务员',
  customerAreaGrouping:'设置客户区域分组',
  customerPriceGrouping:'设置客户价格分组',
  enterCustomerName:'请输入客户名称',
  selectCustomerType:'请选择客户类型',
  enterContactNumber:'请输入联系电话',
  selectArea:'请选择区域',
  enterDetailedAddress:'请输入详细地址',
  selectSalesman:'请选择业务员',
  selectRegionalGrouping:'请选择区域分组',
  selectPriceGroup:'请选择价格分组',
  auditCustomers:'审核客户',
  confirmationPassed:'确认通过?',
  refuse:'拒绝',
  adopt:'通过',
  customerTypeName:'客户类型名称',
  newCustomerType:'新建客户类型',
  typeName:'类型名称',
  editingCustomerType:'编辑客户类型',
  enterTypeName:'请输入类型名称',
  selectTheType:'请选择类型',
  groupName:'分组名称',
  enterContent:'请输入内容',
  regionalGroupingName:'区域分组名称',
  newRegionalGrouping:'新建区域分组',
  editAreaGrouping:'编辑区域分组',
  enterGroupName:'请输入分组名称',
  customerNumber:'客户数',
  salesAmount:'销售金额',
  preferentialWayt:'优惠方式',
  preferentialAmountt:'优惠金额',
  notCountSmallChanget:'抹零',
  amountReceivablet:'应收金额',
  amountReceivedt:'实收金额',
  preferentialDiscountSettings:'优惠折扣设置',
  open:'开',
  shut:'关',
  wholeSingleDiscount:'整单折扣',
  discountPleaseEnters:'如8折,请输入8',
  clickEnterSave:'点击回车保存',
  wholeSingleVerticalReduction:'整单立减',
  wipeSettings:'抹零设置',
  wayPolishing:'抹零方式',
  wipePoints:'抹分',
  makeTurn:'抹角',
  rounding:'四舍五入',
  totalCashCollection:'收银总额',
  cash:'现金',
  alipay:'支付宝',
  weChat:'微信',
  inputRemarks:'输入备注',
  printSmallTicket:'打印小票',
  preferentialTreatment:'选择优惠',
  enterNameNumBarcodeProduct:'请输入商品名称、货号、条码',
  aggregateQuantity:'合计数量',
  totalSum:'合计金额',
  confirmOrder:'确定下单',
  changeAmount:'找零金额',
  confirmPayment:'确定付款',
  pleaseScanningGunScanPayment:'请使用扫描枪扫描顾客手机上的付款码',
  paymentAmounts:'支付金额',
  enterAmountPaid:'请输入实收金额',
  relatedCommodities:'没有相关的商品',
  chooseLeastOneItem:'请至少选择一个商品',
  chooseStore:'请选择门店',
  salesmanInformation:'业务员信息',
  sissionAccomplishmentDuringMonth:'当月任务完成情况',
  todayPerformance:'今日业绩',
  fullName:'姓名',
  aTurnover:'交易额',
  royalty:'提成',
  returnGoods:'退货',
  newCustomer:'新客',
  visit:'拜访',
  newSalesman:'新建业务员',
  salesmanName:'业务员姓名',
  region:'区域',
  editSalesman:'编辑业务员',
  normal:'正常',
  prohibit:'禁用',
  enterYourName:'请输入姓名',
  enterYourAccountNumber:'请输入账号',
  inputPassword:'请输入密码',
  minimumBitsMaximumBits:'最少8位，最大16位',
  months:'月份',
  taskInformation:'任务信息',
  title:'标题',
  term:'期限',
  taskAccomplishment:'任务完成情况',
  taskTitle:'任务标题',
  naturalMonth:'自然月',
  january:'一月',
  february:'二月',
  march:'三月',
  april:'四月',
  may:'五月',
  june:'六月',
  july:'七月',
  august:'八月',
  september:'九月',
  october:'十月',
  november:'十一月',
  december:'十二月',
  missionDeadline:'任务期限',
  selectionTime:'选择时间',
  dateRange:'日期范围',
  enterTaskTitle:'请输入任务标题',
  chooseNaturalMonth:'请选择自然月',
  selectDurationTask:'请选择任务期限',
  enterTransactionAmount:'请输入交易额',
  numberCurrentOrders:'当前订单数',
  completedTransactionVolume:'已完成交易额',
  currentRoyalty:'当前提成',
  repetitionMode:'重复方式',
  repetitionTime:'重复时间',
  taskLine:'任务线路',
  lineRules:'线路规则',
  byRegion:'按区域',
  byCustomer:'按客户',
  never:'从不',
  daily:'每天',
  weekly:'每周',
  monthly:'每月',
  monday:'周一',
  tuesday:'周二',
  wednesday:'周三',
  thursday:'周四',
  sriday:'周五',
  saturday:'周六',
  sunday:'周日',
  lineInformation:'线路信息',
  selectRouteRule:'请选择线路规则',
  chooseRepetitionMode:'请选择重复方式',
  chooseRepetitionTime:'请选择重复时间',
  numNewCustomers:'新增客户数',
  numVisitors:'拜访客户数',
  numSubscribers:'下单客户数',
  dateCheck:'签到日期',
  signDetails:'签到详情',
  taskCompletionRate:'任务完成率',
  signAddress:'签到地址',
  consultMap:'查看地图',
  attendanceStatus:'签到情况',
  customerAddress:'客户地址',
  hangAir:'未完成',
  checkTime:'签到时间',
  signingTime:'签退时间',
  residenceTime:'停留时间',
  address:'地址',
  visitingTasks:'拜访任务量',
  actualVisits:'实际拜访量',
  unvisitedVolume:'未拜访量',
  dateReporting:'上报日期',
  displayArea:'陈列面积',
  picture:'图片',
  addressSubmitted:'上报地址',
  inventoryss:'库存量',
  newType:'新建类型',
  editType:'编辑类型',
  selectTypeAccount:'请选择账目类型',
  retailIncome:'零售收入',
  salesRevenue:'销售收入',
  retailReturns:'零售退货',
  salesReturns:'销售退货',
  procurementExpenditure:'采购支出',
  totalIncome:'收入合计',
  totalExpenditure:'支出合计',
  totalProfitLoss:'盈亏合计',
  transactionTime:'交易时间',
  dataSources:'数据来源',
  newCapitalFlow:'新建资金流水',
  editCapitalFlow:'编辑资金流水',
  selectionDateTime:'选择日期时间',
  expenditure:'支出',
  income:'收入',
  enterAccountType:'请输入账目类型',
  chooseModePayment:'请选择支付方式',
  enterAgent:'请输入经办人',
  enterAmount:'请输入金额',
  nonSystemCannotJump:'非系统不能跳转',
  selectRunningAccount:'请选择流水账目',
  time:'时间',
  thisWeek:'本周',
  thisMonth:'本月',
  lastMonth:'上月',
  cancellationNumber:'退单数',
  withdrawalAmount:'退单额',
  orderRecord:'订货记录',
  returnRecord:'退货记录',
  selectDateRange:'请选择日期范围',
  bySalesVolumeNum:'按销售量',
  bySalesVolume:'按销售额',
  profit:'按利润',
  totalSales:'销售合计',
  salesProfit:'销售利润',
  ranking:'排名',
  salesVolumesNum:'销售量',
  averageSellingPrice:'销售均价',
  salesVolumes:'销售额',
  profits:'利润',
  querySingleCategory:'查询单个分类',
  totalSaless:'总销售额',
  chooseCategory:'请选择分类',
  queryIndividualBrands:'查询单个品牌',
  numberOrderingCustomers:'订货客户数',
  numberReturnedCustomers:'退货客户数',
  orderStatistics:'订单统计',
  royaltyAmount:'提成金额',
  serialNumber:'序号',
  commodityStatistics:'商品统计',
  returnAmount:'退货额',
  customerStatistics:'客户统计',
  numberRefundCustomers:'退款客户数',
  numberVisits:'拜访次数',
  shopNumber:'门店编号',
  newStore:'新建门店',
  editStore:'编辑门店',
  enterStoreNumber:'请输入门店编号',
  enterNameStore:'请输入门店名称',
  employeeName:'员工姓名',
  rolePermissions:'角色权限',
  employeeInformation:'员工信息',
  ascription:'归属',
  employeeType:'员工类型',
  internalService:'内勤',
  permissionSettings:'权限设置',
  storeAuthority:'门店权限',
  customerRights:'客户权限',
  detailsAuthorityAuthority:'权限权限明细',
  chooseOwnership:'请选择归属',
  selectTypeEmployee:'请选择员工类型',
  roleManagement:'角色管理',
  modifyRoleName:'修改角色名称',
  roleName:'角色名称',
  enterRoleName:'请输入角色名称',
  selectRoles:'请选择角色',
  settingAtendanceTime:'设置考勤时间',
  workShift:'上班时间',
  closingTime:'下班时间',
  settingWorkingDays:'设置工作日',
  mondays:'星期一',
  tuesdays:'星期二',
  wednesdays:'星期三',
  thursdays:'星期四',
  friday:'星期五',
  saturdays:'星期六',
  sundays:'星期天',
  holidaysAccordanceStatutoryHolidays:'按照法定假日休假',
  settingAttendanceSites:'设置考勤地点',
  attendanceRange:'考勤范围',
  newAttendanceAddress:'新建考勤地址',
  attendancePointName:'考勤点名称',
  attendanceAddress:'考勤地址',
  enterNameAttendancePoint:'请输入考勤点名称',
  clickMapSelectAttendanceAddress:'请点击地图选择考勤地址',
  newSuccess:'新建成功',
  attendanceRecord:'考勤记录',
  yearChoice:'选择年',
  choiceMonth:'选择月',
  situation:'情况',
  attendanceDays:'出勤天数',
  lateness:'迟到次数',
  earlyRetirementTimes:'早退次数',
  absenteeismFrequency:'旷工次数',
  chooseYear:'请选择年份',
  chooseMonth:'请选择月份',
  rest:'休息',
  missingCard:'缺卡',
  late:'迟到',
  leaveEarly:'早退',
  templateName:'模板名称',
  importTemplate:'导入模板',
  printType:'打印类型',
  printPrint:'按单打印',
  continuousPrinting:'连续打印',
  tableFixing:'表头固定',
  paperType:'纸张类型',
  threeEqualDivision:'三等分',
  twoEqualDivision:'二等分',
  fullPage:'全页',
  wubaxiaop:'58小票',
  balingxiaop:'80小票',
  A4:'A4',
  paperWidth:'纸张宽度',
  paperHeight:'纸张高度',
  templateCode:'模板代码',
  customPictures:'自定义图片',
  previewTemplate:'预览模板',
  uploadUpPicturess:'最多上传2张图片',
  enterpriseLOGO:'企业LOGO',
  membershipNumber:'会员编号',
  industry:'所属行业',
  enterpriseName:'企业名称',
  enterpriseLegalPerson:'企业法人',
  contactCellPhone:'联系手机',
  enterpriseAddress:'企业地址',
  fax:'传真',
  proprietaryBrand:'自营品牌',
  sellableInventoryProcessingRules:'可售库存处理规则',
  outgoingReduction:'出库减',
  orderAuditReduction:'订单审核减',
  orderReduction:'下单立减',
  outgoingReductionDescribe:'出库减：即库存不足时，允许商品销售下单，允许审核订单，待库存充足时，出库时扣减库存。',
  orderAuditReductionDescribe:'订单审核减：即库存不足时，允许商品销售下单，待库存充足时，才可审核订单。',
  orderReductionDescribe:'下单立减：即商品库存不足时，不允许商品销售下单。',
  startUp:'启动',
  noStart:'不启动',
  display:'显示',
  noDisplay:'不显示',
  salesmanCustomerDataRights:'业务员客户数据权限',
  salesmanCustomerDataRightsY:'启动：即业务员或者员工只能对有客户权限的区域客户可见。',
  salesmanCustomerDataRightsN:'不启动：即业务员或者员工对所有客户可见。',
  orderVoiceReminder:'订单语音提醒',
  orderVoiceReminderY:'启动：打开订单语音提醒。',
  orderVoiceReminderN:'不启动：关闭订单语音提醒。',
  showShelfOutWarehouse:'出库时显示保质期',
  showShelfOutWarehouseY:'显示：出库时显示商品剩余保质期(需填写商品保质期和入库生产日期)。',
  showShelfOutWarehouseN:'不显示：出库时不显示商品剩余保质期。',
  abnormalTime:'异常时间',
  orderType:'订单类型',
  abnormalReason:'异常原因',
  intelligence:'智能',
  orderAutomation:'订单自动化',
  makeAppointmentWorkingHours:'预约工作时间',
  startTime:'开始时间',
  endingTime:'结束时间',
  ruleSetting:'规则设置',
  abnormalOrder:'异常订单',
  openAll:'全部开启',
  closeAll:'全部关闭',
  openOrderAutomation:'开启订单自动化，系统将自动完成以下设定任务',
  whenOrderAutomationWorking:'订单自动化在工作状态时，请勿关闭当前页面，否则自动化将停止工作',
  auditOrders:'审核订货单',
  printOrders:'打印订货单',
  auditReturnBill:'审核退货单',
  orderLower:'允许订货单中商品实际销售单价低于默认销售单价',
  orderHigher:'允许订货单中商品实际销售单价高于默认销售单价',
  returnedLower:'允许退货单中商品实际退货单价低于默认销售单价',
  returnedHigher:'允许退货单中商品实际退货单价高于默认销售单价',
  realPriceDefault:'商品实际单价与默认单价差额范围≤',
  orderedExecuted:'允许订货单商品按照上次客户成交单价执行',
  returnExecuted:'允许退货单商品按照上次客户成交单价执行',
  wasteSalesList:'作废销售单',
  singlePerson:'制单人',
  costPriceCannotEmpty:'成本价不能为空',
  warehousingCancellation:'出库作废',
  amountReceiptShouldGreaterUnpaidAmount:'收款金额不能大于未付金额',
  printBarcode:'打印条码',
  noviceCourse:'新手教程',

  //登录
  sysale:'逍逍 · 智能极速销售系统',
  accountNumber:'账号',
  password:'密码',
  automaticLogon:'15天内自动登录',
  login:'登录',
  technicalSupport:'技术支持：成都川三网络科技有限公司 | 服务QQ：3368180746',

  //导航栏
  commodity:'商品',
  listCommodities:'商品列表',
  listGarments:'服装列表',
  merchandiseTime:'临期商品',
  classifiedManagement:'分类管理',
  brandManagement:'品牌管理',
  unitManagement:'单位管理',
  specificationManagement:'规格管理',
  colorManagement:'颜色管理',
  sizeManagement:'尺码管理',

  order:'订单',
  orderForm:'订货单',
  returnOrder:'退货单',
  swapOrder:'换货单',

  stock:'库存',
  inventoryStatus:'库存状况',
  stockStock:'商品入库',
  stockOutStock:'商品出库',
  inventoryAllocation:'库存调拨',
  stockTaking:'库存盘点',

  purchase:'采购',
  purchaseOrder:'采购单',
  purchasePlan:'采购计划',
  supplierManagement:'供应商管理',

  customer:'客户',
  customerList:'客户列表',
  pendingCustomers:'待审客户列表',
  priceGrouping:'价格分组设置',
  customerTypeSettings:'客户类型设置',
  regionalGroupingSettings:'区域分组设置',

  cashRegister:'收银',
  cashier:'前台收银',
  salesRecords:'销售记录',
  dailyRecord:'日结记录',
  cashRegisterSettings:'收银设置',

  sale:'销售',
  salesSlip:'销售单',

  fieldPersonnel:'外勤',
  salesmanList:'业务员列表',
  taskManagement:'任务管理',
  attendanceManagement:'签到管理',
  taskReporting:'任务上报',

  finance:'财务',
  accountType:'账目类型',
  capitalFlow:'资金流水',

  microShop:'微店',
  bindingMicrostores:'绑定微店铺',
  generalStoreSettings:'店铺通用设置',
  merchandiseDisplay:'首页商品展示',
  advertisingSpace:'首页广告位',
  fistributionMode:'配送方式',
  paymentMethod:'支付方式',
  myBalance:'我的余额',

  reportForm:'报表',
  salesReport:'销售报表',
  commodityStatement:'商品报表',
  orderReport:'订单报表',
  performanceReport:'业绩报表',

  setUp:'设置',
  storeManagement:'门店管理',
  employeeAccountNumber:'员工账号',
  privilegeManagement:'权限管理',
  attendanceSettings:'考勤设置',
  printSetup:'打印设置',
  companyInformation:'公司信息',
  systemSetup:'系统设置',

  //index
  productEnglish:'Sysale',
  productChinese:'逍逍',
  refresh:'刷新',
  contactCustomerService:'联系客服',
  visitOfficialWebsite:'访问官网',
  returnVersion:'返回旧版',
  officialPublicNumber:'官方公众号',
  signOut:'退出',
  twoInconsistent:'两次输入不一致！',
  homepage:'主页',

  //home
  pendingDisposal:'待处理',
  productInformation:'产品信息',
  generalSituation:'经营概况',
  download:'下载',
  orderMonth:'本月订单',
  viewReport:'查看报表',
  officialAnnouncement:'官方公告',
  returnPendingReview:'退货待审核',
  exchangePendingReview:'换货待审核',
  lastLogonTime:'上次登录时间',
  currentVersion:'当前版本',
  openingTime:'开通时间',
  dueTime:'到期时间',
  bindingWeChat:'绑定微信',
  totalOrdersToday:'今日订单总数',
  totalOrderToday:'今日订单总额',
  grossProfitTodaySales:'今日销售毛利',
  customerArrears:'客户欠款额',
  totalInventoryCost:'库存总成本',
  pcClient:'PC客户端',
  iosMobile:'iOS手机端',
  androidMobile:'Android手机端',
  buttonDownload:'点击按钮下载',
  scanCodeDownload:'扫描二维码下载',
  simplifiedVersion:'简体版',
  traditionalEdition:'繁体版',
  learnMore:'了解更多',
  remind:'提醒',
  yourService:'您的服务',
  needHelp:'如您需要帮助，请联系我们',
  contactInformation:'微信QQ：2441675837，QQ客服：3368180746',
  sort:'排序',
  ICP:'蜀ICP备16011618号',

  //router
  systemName:'逍逍(Sysale)智能极速销售系统',
  addGoods:'新建商品',
  editGoods:'编辑商品',
  seeGoods:'商品详情',
  addClothing:'新建服装',
  editClothing:'编辑服装',
  addOrderGoods:'新建订货单',
  editOrderGoods:'编辑订货单',
  seeOrderGoods:'查看订货单',
  addReturnBill:'新建退货单',
  seeReturnBill:'查看退货单',
  addswapOrder:'新建换货单',
  seeswapOrder:'查看换货单',
  inventoryDetails:'库存明细',
  storeInventory:'门店库存',
  addWarehousing:'新建入库单',
  editWarehousing:'编辑入库单',
  seeWarehousing:'查看入库单',
  addOutgoing:'新建出库单',
  editOutgoing:'编辑出库单',
  seeOutgoing:'查看出库单',
  addAllocation:'新建调拨单',
  editAllocation:'编辑调拨单',
  seeAllocation:'查看调拨单',
  addCheck:'新建盘点单',
  editCheck:'编辑盘点单',
  seeCheck:'查看盘点单',
  addPurchase:'新建采购单',
  editPurchase:'编辑采购单',
  seePurchase:'查看采购单',
  storagePurchase:'采购入库',
  recordsConsumption:'历史消费记录',
  returnRecords:'退货记录',
  seeSalesRecord:'查看销售记录',
  seeReturnRecord:'查看退货记录',
  paymentSettings:'支付设置',
  addSalesSlip:'新建销售单',
  editSalesSlip:'查看销售单',
  addTask:'新建任务',
  editTask:'编辑任务',
  seeTask:'查看任务',
  signTask:'签到任务',
  signSituation:'签到情况',
  monthlySummary:'月度汇总',
  addSignTask:'新建签到任务',
  editSignTask:'编辑签到任务',
  seeSignTask:'查看签到任务',
  displayInspection:'陈列检查',
  photoRecord:'拍照记录',
  stockReport:'库存上报',
  classifiedReport:'分类报表',
  brandReport:'品牌报表',
  seeAchievement:'查看业绩详情',
  salesmanAccount:'业务员账号',
  addEmployee:'新建员工',
  editEmployee:'编辑员工',
  attendanceSummary:'考勤汇总',
  orderTemplate:'订货单模板',
  warehousingTemplate:'入库单模板',
  exitTemplate:'出库单模板',
  callTemplate:'调拨单模板',
  purchasingTemplate:'采购单模板',
  cashTemplate:'收银单模板',
}



// WEBPACK FOOTER //
// ./src/assets/js/zh-cn.js